import React from 'react';

import { HorizontalDraggableList } from './horizontal/HorizontalDraggableList';
import { VerticalDraggableList } from './vertical/VerticalDraggableList';
import { DraggableListProps } from './shared';
import { HorizontalWrapDraggableList } from './horizontal/HorizontalWrapDraggableList';

interface DragDropProps extends DraggableListProps {
    type?: 'vertical' | 'horizontal' | 'wrap';
    draggableItemHeight?: string;
    draggableItemWidth?: string;
}

export const DragDrop: React.FC<DragDropProps> = ({ getChildElement, list, listId, type = 'vertical', updateList, getDraggingElement, edgeColour, edgeWidth, draggableItemHeight, draggableItemWidth, withScrollable }) => {
    if (type === 'horizontal') {
        return (
            <HorizontalDraggableList
                getChildElement={getChildElement}
                getDraggingElement={getDraggingElement}
                list={list}
                listId={listId}
                updateList={updateList}
                edgeColour={edgeColour}
                edgeWidth={edgeWidth}
                draggableItemHeight={draggableItemHeight}
                draggableItemWidth={draggableItemWidth}
                withScrollable={withScrollable}
            />
        );
    }

    if (type === 'wrap') {
        return (
            <HorizontalWrapDraggableList
                getChildElement={getChildElement}
                getDraggingElement={getDraggingElement}
                list={list}
                listId={listId}
                updateList={updateList}
                edgeColour={edgeColour}
                edgeWidth={edgeWidth}
                draggableItemHeight={draggableItemHeight}
                draggableItemWidth={draggableItemWidth}
            />
        );
    }

    return (
        <VerticalDraggableList
            getChildElement={getChildElement}
            getDraggingElement={getDraggingElement}
            list={list}
            listId={listId}
            updateList={updateList}
            edgeColour={edgeColour}
            edgeWidth={edgeWidth}
            draggableItemHeight={draggableItemHeight}
            draggableItemWidth={draggableItemWidth}
        />
    );
};
